import { connect } from 'react-redux'

import SimilarPhotos from './similarPhotos'

import { decorateSearchResult } from '../../../../../common/selectors/searchResults'

const mapStateToProps = (state, ownProps) => {
  const { searchPage: { similarItems, results: { matches } } } = state
  const { layout: { selectedItemId } } = state

  const item = matches.find(item => item.id === selectedItemId)

  const itemsLoaded = similarItems[item.id] && !similarItems[item.id].error

  let items = itemsLoaded ? [item, ...similarItems[item.id].matches] : [item]

  return { items: items.map(i => decorateSearchResult(state, i)) }
}

const SimilarPhotosContainer = connect(mapStateToProps, null)(SimilarPhotos)

export default SimilarPhotosContainer
